export default __webpack_public_path__ + "static/peopleCalling-dc8100dde76ef31bacd60913e3b0340a.png";